import Dialog from '@comp/Dialog/Dialog';
import { plannerEventTypes } from '@constants/schedule';
import PropTypes from 'prop-types';
import { GroupObjectType } from 'types/groups';
import * as React from 'react';

const eventTypeMessages = {
  [plannerEventTypes.LIVE_INTERACTION]: {
    message:
      'At the moment, 1:1 live mentorship sessions can only be joined from our Android app.'
  },
  [plannerEventTypes.COMBAT]: {
    message:
      'At the moment, the Combat tests can only be joined from our Android app.'
  },
  [GroupObjectType.READING_NOTES]: {
    message: 'At the moment, notes can only be accessed from our Android app.'
  },
  [plannerEventTypes.OPENHOUSE]: {
    message:
      'At the moment Openhouse rooms can only be joined from our Android app.'
  }
};

interface INotAvailableDialogProps {
  eventType: any;
  onClose: any;
}

const NotAvailableDialog: React.FC<INotAvailableDialogProps> = ({
  eventType,
  onClose
}) => (
  <Dialog
    dialogState
    borderRadius="8px"
    type="informative"
    heading="Join from the android app"
    message={eventTypeMessages[eventType].message}
    acceptLabel="Got it"
    acceptLabelTheme="black"
    onClose={onClose}
    acceptOnClick={onClose}
  />
);

export default NotAvailableDialog;

NotAvailableDialog.propTypes = {
  onClose: PropTypes.func.isRequired
};
